import React from 'react';
const testimonials = [{
  name: 'Martina C.',
  role: 'Insegnante di 3ª classe',
  city: 'Milano',
  text: 'Finalmente un kit artistico davvero completo. I bambini adorano ogni laboratorio.',
  stars: 5
}, {
  name: 'Giulia F.',
  role: 'Insegnante di 1ª classe',
  city: 'Roma',
  text: 'Ho smesso di perdere ore su Pinterest. Apro il volume e insegno.',
  stars: 5
}, {
  name: 'Elena R.',
  role: 'Insegnante di 5ª classe',
  city: 'Napoli',
  text: "La mia classe aspetta l'ora di arte come il momento più bello della settimana.",
  stars: 5
}, {
  name: 'Sara P.',
  role: 'Insegnante di sostegno',
  city: 'Bologna',
  text: 'Le attività BES/DSA sono fantastiche e facili da usare.',
  stars: 5
}, {
  name: 'Valentina T.',
  role: 'Insegnante di 2ª classe',
  city: 'Torino',
  text: 'La Dirigente mi ha chiesto dove trovassi tutte queste idee creative 😄',
  stars: 5
}, {
  name: 'Chiara L.',
  role: 'Insegnante di 4ª classe',
  city: 'Firenze',
  text: 'Le guide docente sono chiarissime e i materiali richiesti sono sempre semplici da reperire.',
  stars: 5
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 border-t border-border-light/50" data-id="element-382">
      <div className="max-w-5xl mx-auto" data-id="element-383">
        <div className="text-center mb-14" data-id="element-384">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-385">
            Cosa dicono le maestre
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-386">
            Oltre <span className="text-primary font-bold" data-id="element-387">18.000 docenti</span>{' '}
            hanno già scelto ARTE PRONTA
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-388">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-6 flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300 relative overflow-hidden group" data-id="element-389">
              {/* Subtle hover glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-390"></div>

              {/* Stars */}
              <div className="flex items-center gap-0.5 relative z-10" data-id="element-391">
                {Array.from({
              length: t.stars
            }).map((_, j) => <span key={j} className="text-secondary text-lg" data-id="element-392">
                    ⭐
                  </span>)}
              </div>

              {/* Quote */}
              <p className="text-text-main text-base leading-relaxed font-medium relative z-10 flex-1" data-id="element-393">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-border-light/50 relative z-10" data-id="element-394">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 flex items-center justify-center shadow-inner flex-shrink-0" data-id="element-395">
                  <span className="text-sm font-bold text-primary" data-id="element-396">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-397">
                  <p className="text-text-main font-bold text-sm" data-id="element-398">{t.name}</p>
                  <p className="text-text-sec text-xs" data-id="element-399">
                    {t.role} · {t.city}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}